import React, { useState, useEffect } from 'react';
import WidgetButton from './WidgetButton';
import { ContactFormData, WidgetProps } from '../types';
import { ensureSession } from '../api/auth';
import { SessionData } from '../api/interfaces/ApiInterfaces';

const HectorWidget: React.FC<WidgetProps> = ({ 
  config = { position: 'bottom' }, 
  onSubmit 
}) => {
  const [sessionData, setSessionData] = useState<SessionData | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialiser la session automatiquement au montage du composant
  useEffect(() => {
    const initializeSession = async () => {
      try {
        console.log('🚀 Initialisation automatique de la session...');
        const session = await ensureSession();
        if (session) {
          setSessionData(session);
          console.log('✅ Session initialisée avec succès:', session);
        } else {
          console.warn('⚠️ Impossible d\'initialiser la session, mais le widget fonctionnera quand même');
        }
      } catch (error) {
        console.error('❌ Erreur lors de l\'initialisation de la session:', error);
        console.log('ℹ️ Le widget fonctionnera quand même sans session');
      } finally {
        setIsInitialized(true);
      }
    };

    initializeSession();
  }, []);

  // Fonction pour gérer la soumission du formulaire
  const handleFormSubmit = (data: ContactFormData) => {
    console.log('📝 Données du formulaire reçues:', data);
    console.log('🔑 Données de session:', sessionData);
    
    if (onSubmit) {
      onSubmit(data);
    } else {
      // Comportement par défaut - afficher les données dans la console
      console.log('✅ Formulaire envoyé avec succès !');
      alert('Formulaire envoyé avec succès !');
    }
  };

  // Ne pas afficher le widget tant qu'il n'est pas initialisé
  if (!isInitialized) {
    return null;
  }

  return (
    <WidgetButton 
      config={{
        ...config,
        onSubmit: handleFormSubmit
      }}
      sessionData={sessionData}
    />
  );
};

export default HectorWidget;
